
export const HelperSectionValues = [
  {
    heading: "Links",
    data: "You can add your links by adding text inside of [] and links inside of () , like so",
    example: "[link text] (www.google.com)",
  },
  {
    heading: "Lists",
    data: "To add a numbered list you can simply start wit a number and ., like so ",
    example: "1. The first item in my list ",
  },

  {
    heading: "Images",
    data: "You can add images by selecting the image icon, which will upload and add image to the editor, or you can manually add the image by adding !exclamation , followed by alt text inside [] and and image url inside() , like so",
    example: "![alt text for image ] (url_to_image.png)",
  },

  {
    heading: "Dividers",
    data: "To add a divider you can add three dashes or three astericks ",
    example: "--- or ***",
  },
  {
    heading: "Embedding You tube Videos",
    data: "You can also Embdding YouTube video by following  ",
    example: "% youtube VIDEO_ID_HERE %",
  },
  {
    heading: "Embedding google slides",
    data: "You can also Embed your buy me coffe button by writing following ",
    example: "% google slides SLIDES_URL_HERE %",
  },
];
